
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  get isMobile() {
    return AppModule.narrow;
  }
}
